(function() {
  window.miniMakeUpsell = {
    init: function() {
      // Upsell disabled — restore click listener + real pendingShow below to re-enable
      window.miniMakeUpsell.pendingShow = function() {
        window.location.href = '/cart';
      };
    }
  };
})();